import { Text } from '@ui-component-library';

import type { Product } from '../../Checkout.types';

export function SelectProductSummaryRow({ product }: { product: Product }) {
  return (
    <Text variant="text-sm/leading-normal/normal" className="capitalize">
      {product.name.toLowerCase()}
    </Text>
  );
}
